// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import vueAxios from 'vue-axios'

import '@/assets/css/reset.css'
import '@/assets/css/common.less'
import common from "./assets/js/common"

// import 'amfe-flexible';
// import 'lib-flexible/flexible'

import ElementUI from 'element-ui'
// import 'nprogress/nprogress.css'
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
Vue.prototype.$common = common;
Vue.config.productionTip = false


axios.defaults.withCredentials = true
Vue.use(vueAxios, axios)
Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(NProgress);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


let load;
// 设置请求拦截器
axios.interceptors.request.use(config => {
  load = ElementUI.Loading.service({
    lock: true,
    background: "rgba(0, 0, 0, 0.2)",
    text: "请求中,请稍后..."
  });
  if (localStorage.getItem('loginToken')) {
    config.headers.Authorization = localStorage.getItem('loginToken')
  }
  // if(config.type == 'formData' || config.method != 'post'){
  //   return config
  // }
  // config.data = qs.stringify(config.data)
  return config;
}, error => {
  return Promise.reject(error);
});

// 设置响应拦截器
axios.interceptors.response.use(res => {
  load.close()
  return res
}, error => {
  load.close()
  // 如果是正常接口，会走err，err.response.status值为401 进行跳转及删除token的操作
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return Promise.reject("400");
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        localStorage.removeItem('loginToken')
        location.reload()
        return Promise.reject("登录已过期,请重新登录");
      case 403:
        return Promise.reject("你没权限查询该资源");
      case 404:
        return Promise.reject("你所访问的资源不存在");
      case 500:
        return Promise.reject("服务器开小差拉,请重新登录尝试");
    }
  }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/main.js